const Products = {
  methods: {
    // 面料展示
    fabric(row) {
      if (!row) return false;
      let content = '';
      if (row.productFabrics && row.productFabrics.length > 0) {
        row.productFabrics.forEach(item => {
          let unitPrice = item.fabricName === '真皮' ?
            '¥' + item.fabricUnitPrice + '/ft2' :
            '¥' + item.fabricUnitPrice + '/m';

          if (!item.fabricUnitPrice) {
            unitPrice = '';
          }
          let consumption = item.fabricName === '真皮' ?
            item.fabricConsumption + 'ft2/' :
            item.fabricConsumption + 'm/';
          if (!unitPrice) {
            consumption = item.fabricName === '真皮' ?
              item.fabricConsumption + 'ft2' :
              item.fabricConsumption + 'm';
          }
          let position = item.fabricUsePosition ?
            '/' + item.fabricUsePosition :
            '';

          let _item = `${item.fabricName || ''}/${consumption || ''}${unitPrice}${position};`;
          content = content + _item;
        });
      }
      return content;
    },

    // 显示主图
    coverImg(item) {
      if (!item) return false;
      if (item.specs && item.specs.length > 0 && item.specs[0].specFile) {
        return item.specs[0].specFile.key;
      } else {
        return item.coverFile && item.coverFile.key;
      }
    },

    /* 是否显示下架 */
    disabledShow(item) {
      if (!item) return false;
      if (item.disabled === 0) {
        if (item.specs[0].visible) {
          return false;
        } else {
          return true
        }
      } else {
        return true;
      }
    }
  },
};

export default Products